export const LOCAL_STORAGE_FLOW_STATES_KEY = '::zenbusiness::shopping-ui::flow-states';
export const LOCAL_STORAGE_SHOP_STATE_KEY = '::zenbusiness::shopping-ui::shop-state';

export const LOCAL_STORAGE_FLOW_STATE_DEFAULT = {
  accountUuid: null,
  businessInfo: {
    businessEntityUuid: null,
    formationCounty: null,
    jurisdictionState: null,
    previousJurisdictionState: null,
    name: null,
    // boi
    companyIndicator: null,
    // business questions
    industry: null,
    businessExperience: null,
    businessStage: null,
    website: null
  },
  cartUuid: null,
  configHash: null,
  contactInfo: {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    pageSource: null
  },
  lastPage: null,
  orderUuid: null,
  trackingParams: {
    affiliate: null,
    audienceType: null,
    entryUri: null
  }
};

export const LOCAL_STORAGE_SHOP_STATE_DEFAULT = {
  lastFlowId: null,
  lastOrderUuid: null,
};

export const LOCAL_STORAGE_LEAD_UUID_KEY = 'LEAD_UUID';
export const LOCAL_STORAGE_VISIT_UUID_KEY = 'visitUUID';
export const LOCAL_STORAGE_APPS_FLYER_ID_KEY = 'appsflyer_id';
